import React from 'react';
import './FilterStyles.css';

const TENURE_TYPES = [
  'Owned Outright',
  'Mortgage/Shared',
  'Social Rented',
  'Private Rented'
];

const TenureFilter = ({ filter, onUpdate, onRemove }) => {
  const { tenureTypes = [] } = filter.values;

  const handleToggle = (tenure) => {
    const newTenureTypes = tenureTypes.includes(tenure)
      ? tenureTypes.filter(t => t !== tenure)
      : [...tenureTypes, tenure];

    onUpdate({
      ...filter,
      values: { ...filter.values, tenureTypes: newTenureTypes }
    });
  };

  return (
    <div className="filter-container">
      <div className="filter-header">
        <h3>Tenure</h3>
        <button className="filter-remove-btn" onClick={onRemove}>×</button>
      </div>

      <div className="filter-section">
        {TENURE_TYPES.map(tenure => (
          <label key={tenure} className="filter-checkbox">
            <input
              type="checkbox"
              checked={tenureTypes.includes(tenure)}
              onChange={() => handleToggle(tenure)}
            />
            <span>{tenure}</span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default TenureFilter;
